<div class="h-full">
    <h2 class="m-0 mb-2 text-xl text-[var(--color-text-strong)]">
        {{ 'user-management.dialogs.delete-dialog.heading' | translate }}
    </h2>
    <p class="m-0 text-base text-[var(--color-text-subtle)]">
        {{ 'user-management.dialogs.delete-dialog.subheading' | translate }}
        <b class="text-[var(--color-text-strong)]">{{ data?.firstName }} {{ data?.lastName }} ({{ data?.gid }}).</b>
    </p>

    <div class="mt-5 flex items-center justify-end gap-2">
        <sh-button
            color="secondary"
            icon="arrow-line-left-s"
            iconPosition="left"
            size="max-content"
            [label]="'user-management.dialogs.delete-dialog.cancel' | translate"
            [ariaLabel]="'user-management.dialogs.delete-dialog.cancel' | translate"
            (clicked)="cancel()"
        />

        <sh-button
            color="danger"
            icon="delete"
            iconPosition="left"
            size="max-content"
            [label]="'user-management.dialogs.delete-dialog.confirm' | translate"
            [ariaLabel]="'user-management.dialogs.delete-dialog.confirm' | translate"
            (clicked)="deleteUser()"
        />
    </div>
</div>
